export class TextMesh {
    get text() {
        return this._text;
    }
    set text(value) {
        this._text = value;
    }
    get fontSize() {
        return this._fontSize;
    }
    set fontSize(value) {
        this._fontSize = value;
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
    }
    constructor() {
    }
}
